import React from "react"
import { Link } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import slugify from "slugify"
import MiniHeaderWorks from "../MiniHeaderWorks"
import styled from "@emotion/styled"

const Title = styled.h3`
    text-align: left;
    -webkit-transition: all .7s ease-in-out;
    -o-transition: all .7s ease-in-out;
    -moz-transition: all .7s ease-in-out;
    transition: all .7s ease-in-out;
    margin-top: 5px;
    border-top: 1px solid #999;
    position: relative;
    bottom: 0;
    padding: 4px; 
`;

const TitleBold = styled.h3`
    text-align: left;
    -webkit-transition: all .7s ease-in-out;
    -o-transition: all .7s ease-in-out;
    -moz-transition: all .7s ease-in-out;
    transition: all .7s ease-in-out;
    margin-top: 5px;
    border-top: 1px solid #999;
    position: relative;
    bottom: 40px;
    padding: 4px; 
    opacity:0;
    width:100%;
    
    position: absolute;
    font-weight: 900;
    span {
      position:relative;
      top:400px;
    }
`;


const GridImg = styled.div`
  -webkit-box-shadow: 2px 2px 4px 1px rgba(0,0,0,.3);
  box-shadow: 2px 2px 4px 1px rgba(0,0,0,.3);
  -webkit-transition: all .7s ease-in-out;
  -o-transition: all .7s ease-in-out;
  -moz-transition: all .7s ease-in-out;
  transition: all .7s ease-in-out;
  margin-bottom: 10px;
  
`;

const MainGrid = styled.div`
  margin-bottom:70px;
`;

const PhotoHolder = styled.div`
  overflow: hidden;
  position: relative;
  -webkit-transition: all .5s ease-in-out;
  -o-transition: all .5s ease-in-out;
  -moz-transition: all .5s ease-in-out;
  transition: all .5s ease-in-out;
 
  a{
    overflow:hidden;

  }

  :hover{
    a {
      color: rgba(0,0,0,.9);
    }

    ${Title} {
      bottom: 0px;
      opacity:0;
    }

    ${TitleBold} {
      bottom: 1px;
      width: 100%;
      border-width: 2px;
      border-color: rgba(0,0,0,.2);
      background: #f1f1f1;
      opacity:1;
      span {
        top:0;
        -webkit-transition: all .8s ease-out;
        -o-transition: all .8s ease-out;
        -moz-transition: all .8s ease-out;
        transition: all .8s ease-out;
        
      }
    }

    ${GridImg} {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
      border: 4px solid #333;
      border-radius:5px;
    }
  }
`;


const Grid = ({ images, style, prefix, title, archived, imagePreview, description, descriptionShort, exhibitions, publications, awards, pageArcvhive= false }) => {
  console.log('test', description)

  if (prefix.toLowerCase() !== "main") {
    /* images.shift(); */
  }

  return (<MainGrid>

    {prefix.toLowerCase() !== "main" && imagePreview ? (
      <MiniHeaderWorks title={title} description={description} descriptionShort={descriptionShort} awards={awards} exhibitions={exhibitions} publications={publications} imagePreview={imagePreview} />
    ) : (
      ""
    )}
    <ResponsiveMasonry style={style}>
      <Masonry gutter="1rem">
        {
          images.map(function (item, i) {
            if (pageArcvhive || !pageArcvhive && !item.archived) {
              console.log("item", images.length)
              let link = `${prefix ? slugify(prefix).toLowerCase() + "/" : ""}${slugify(item.title.toLowerCase())}`;
              let preview = null;
              if (item) {
                preview = item.gatsbyImageData;
                if (prefix.toLowerCase() == "main") {
                  link = "/"+slugify(item.title).replaceAll("'", "-").toLowerCase();
                  preview = item.preview.gatsbyImageData;
                }
              }
              //console.log("link",link,prefix)
              return (
                <PhotoHolder key={i} >
                  <Link
                    id={"photo-" + i}
                    key={i}
                    to={link}
                  >
                    <GridImg>
                      <GatsbyImage alt={item.title} image={getImage(preview)} />
                    </GridImg>
                    {prefix.toLowerCase() == "main" && (
                      <>
                        <Title>{item.title}</Title>
                        <TitleBold><span>{item.title}</span></TitleBold>
                      </>
                    )}
                  </Link>
                </PhotoHolder>
              )
            }
          })

        }
      </Masonry>
    </ResponsiveMasonry>
  </MainGrid>
  )
}

export default Grid


/* 
import React, { useState } from 'react';
import { Link } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import slugify from "slugify"
import MiniHeaderWorks from "../MiniHeaderWorks"
import styled from "@emotion/styled"

const Title = styled.h3`
    text-align: left;
    -webkit-transition: all .7s ease-in-out;
    -o-transition: all .7s ease-in-out;
    -moz-transition: all .7s ease-in-out;
    transition: all .7s ease-in-out;
    margin-top: 5px;
    border-top: 1px solid #999;
    position: relative;
    bottom: 0;
    padding: 4px; 
`;

const TitleBold = styled.h3`
    text-align: left;
   

    background:#fff;
    margin-top: 5px;
    border-top: 1px solid #999;
    position: relative;
    bottom: 40px;
    padding: 4px; 
    opacity:0;
    width:100%;

    
    
    position: absolute;
    font-weight: 900;
    
    

    transition:
    background 0.5s ease-in-out 0.1s,
    opacity 0.5s ease-in-out 0s,
    bottom 0.7s ease-in-out,
    padding-left 1s ease-in-out 2s;

   
    span {
      position:relative;
      top:400px;
    }
`;


const GridImg = styled.div`
  -webkit-box-shadow: 2px 2px 4px 1px rgba(0,0,0,.3);
  box-shadow: 2px 2px 4px 1px rgba(0,0,0,.3);
  -webkit-transition: all .7s ease-in-out;
  -o-transition: all .7s ease-in-out;
  -moz-transition: all .7s ease-in-out;
  transition: all .7s ease-in-out;
  margin-bottom: 10px;
  
`;


const PhotoHolder = styled.div`
  overflow: hidden;
  position: relative;
  -webkit-transition: all .5s ease-in-out;
  -o-transition: all .5s ease-in-out;
  -moz-transition: all .5s ease-in-out;
  transition: all .5s ease-in-out;
  max-width: 500px;
  
  a{
    overflow:hidden;

  }

  :hover {
    
    a {
      color: rgba(0,0,0,.9);
    }

    ${Title} {
      bottom: 0px;
      opacity:0;
    }

    ${TitleBold} {
      transition:     
      opacity 0.5s ease-in-out 0.3s;


      bottom: 1px;
      width: 100%;
      border-width: 2px;
      border-color: rgba(0,0,0,.2);
      background: #222;
      color:#fff;
      padding-left:10px;
      opacity:1;
      
      span {
        top:0;
        -webkit-transition: all .8s ease-out;
        -o-transition: all .8s ease-out;
        -moz-transition: all .8s ease-out;
        transition: all .8s ease-out;
        
      }
    }

    ${GridImg} {
      -webkit-filter: grayscale(0%);
      filter: grayscale(0%);
      border: 4px solid #333;
      border-radius:5px;
      -webkit-transition: all .8s ease-out;
      -o-transition: all .8s ease-out;
      -moz-transition: all .8s ease-out;
      transition: all .8s ease-out;
    }
  }

  &.over {
    ${GridImg} {
      -webkit-filter: grayscale(0%);
      filter: grayscale(0%);
      border: 4px solid #333;
      border-radius:5px;
      opacity:1
    }
  }

  &.out {
    ${GridImg} {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
      opacity:0.9;
     
    }
  }
`;

const MainGrid = styled.div`
  margin-bottom:70px;
`;




const Grid = ({ images, style, prefix, title, imagePreview, description, descriptionShort, exhibitions, publications, awards }) => {
  console.log('test', description)
  const [overIndex, setOverIndex] = useState(null);
  if (prefix.toLowerCase() !== "main") {
    images.shift();
  }

  return (<MainGrid >

    {prefix.toLowerCase() !== "main" && imagePreview ? (
      <MiniHeaderWorks title={title} description={description} descriptionShort={descriptionShort} awards={awards} exhibitions={exhibitions} publications={publications} imagePreview={imagePreview} />
    ) : (
        ""
      )}
    <ResponsiveMasonry style={style}>
      <Masonry gutter="1rem">
        {
          images.map(function (item, i) {
            console.log("item", item)
            let link = `${prefix ? slugify(prefix).toLowerCase() + "/" : ""}${slugify(item.title.toLowerCase())}`;
            let preview = null;
            if (item) {
              preview = item.gatsbyImageData;
              if (prefix.toLowerCase() == "main") {
                link = slugify(item.title).replaceAll("'", "-").toLowerCase();
                preview = item.preview.gatsbyImageData;
              }
            }
            //console.log("link",link,prefix)
            return (
              <PhotoHolder className={overIndex == i ? "over" : overIndex == null ? "" : "out"} key={i} onMouseEnter={() => setOverIndex(i)} onMouseLeave={() => setOverIndex(null)}>
                <Link
                  id={"photo-" + i}
                  key={i}
                  to={link}
                >
                  <GridImg>
                    <GatsbyImage alt={item.title} image={getImage(preview)} />
                  </GridImg>
                  {prefix.toLowerCase() == "main" && (
                    <>
                      <Title>{item.title}</Title>
                      <TitleBold><span>{item.title}</span></TitleBold>
                    </>
                  )}
                </Link>
              </PhotoHolder>
            )
          })
        }
      </Masonry>
    </ResponsiveMasonry>
  </MainGrid>
  )
}

export default Grid


*/